import React from 'react'

import { Form } from '_zari/core'

import { MonedasConstant } from 'constants/index'

const MonedaSelect = props => {
  return (
    <Form.Select {...props}>
      <option value=''>Seleccionar</option>
      {MonedasConstant.__array.map((x, k) => (
        <option key={k} value={x.id}>
          {x.nombre}
        </option>
      ))}
    </Form.Select>
  )
}

export default React.memo(MonedaSelect)
